import messages from "res/messages/farsi";

export default function getDateString(date, sepratopr) {
    if (date) {
        if (!sepratopr) {
            sepratopr = "-"
        }
        let array = date.split(sepratopr)
        return parseInt(array[2]) + " " + getMonthString(array[1]) + " " + array[0]
    }
}

function getMonthString(month) {
    if (month === '1' || month === '01') {
        return messages.farvardin
    } else if (month === '2' || month === '02') {
        return messages.ordibehesht
    } else if (month === '3' || month === '03') {
        return messages.khordad
    } else if (month === '4' || month === '04') {
        return messages.tir
    } else if (month === '5' || month === '05') {
        return messages.mordad
    } else if (month === '6' || month === '06') {
        return messages.shahrivar
    } else if (month === '7' || month === '07') {
        return messages.mehr
    } else if (month === '8' || month === '08') {
        return messages.aban
    } else if (month === '9' || month === '09') {
        return messages.azar
    } else if (month === '10') {
        return messages.dey
    } else if (month === '11') {
        return messages.bahman
    } else if (month === '12') {
        return messages.esfand
    }
}